import React from 'react';
import { Select } from '@trussworks/react-uswds';

export function USWDSSelect(props) {
  return <Select {...props} />;
}
